var AdobeAn;
import 'latest-createjs';

(function (cjs, an) {

    var p; // shortcut to reference prototypes
    var lib = {};
    var ss = {};
    var img = {};
    lib.ssMetadata = [];


// symbols:


    (lib._08_intro = function () {
        this.initialize(img._08_intro);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 1500, 900);


    (lib.Bitmap1 = function () {
        this.initialize(img.Bitmap1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 588, 505);


    (lib.Bitmap2 = function () {
        this.initialize(img.Bitmap2);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 624, 227);


    (lib.gilza = function () {
        this.initialize(img.gilza);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 83, 82);


    (lib.pig = function () {
        this.initialize(img.pig);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 166, 130);


    (lib.pistl = function () {
        this.initialize(img.pistl);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 606, 574);


    (lib.skull = function () {
        this.initialize(img.skull);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 205, 313);// helper functions:

    function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }


    (lib.shapes12 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill('#262626').beginStroke().moveTo(69, 264.6).curveTo(51.2, 258.6, 38.6, 246.2).curveTo(9, 217, 13.2, 158.7).curveTo(15.3, 129.3, 10.7, 107.3).curveTo(5.5, 82.8, -7.4, 71.5).curveTo(-21.8, 58.8, -44.7, 63.8).curveTo(-70.3, 69.3, -105.2, 96.7).curveTo(-126.6, 113.4, -147.4, 113.4).curveTo(-165.6, 113.4, -181, 100.9).curveTo(-194.9, 89.8, -203, 72).curveTo(-210.8, 54.9, -210, 39.3).curveTo(-209.3, 25.1, -201.3, 15.1).curveTo(-196.5, 9.2, -184, 0.2).curveTo(-171.8, -8.6, -167.1, -14.8).curveTo(-159.5, -24.8, -159.5, -39.2).curveTo(-159.5, -57.9, -186.8, -79.1).curveTo(-195.3, -85.6, -207.2, -92.9).lineTo(-219.8, -100.6).curveTo(-234, -111.2, -238.1, -134.3).curveTo(-240.1, -145.4, -240.1, -172).curveTo(-240.1, -188.7, -233.4, -206).curveTo(-226.7, -223.2, -214.8, -237.3).curveTo(-202.3, -252, -186.3, -260.3).curveTo(-169.1, -269.3, -150.2, -269.5).curveTo(-100, -269.9, -69.5, -248.8).curveTo(-36, -225.7, -24.7, -175.8).curveTo(-12.9, -123.6, 4.2, -98).curveTo(26, -65.4, 61.2, -65.4).curveTo(73.4, -65.4, 86.2, -69.4).curveTo(93.9, -71.9, 108.2, -78.3).curveTo(122.6, -84.7, 130.2, -87.1).curveTo(142.8, -91.1, 154.7, -91.1).curveTo(177.8, -91.1, 197.2, -83.9).curveTo(215.6, -77, 226.9, -65.1).curveTo(238.3, -53.1, 239.9, -38.9).curveTo(241.6, -23.9, 232, -9.5).curveTo(228.4, -4, 219.4, 5.1).lineTo(202.5, 22.2).curveTo(180, 46.4, 171, 71.3).curveTo(162.4, 95.1, 164.5, 130.7).curveTo(166.7, 170.3, 181.8, 204).curveTo(187.1, 216, 182.5, 228).curveTo(178.3, 239.2, 166.2, 248.6).curveTo(154.5, 257.7, 138.2, 263.3).curveTo(121.6, 268.9, 104, 269.4).lineTo(100.6, 269.5).curveTo(83.7, 269.5, 69, 264.6).closePath();
        this.shape.setTransform(0.0284, -0.0293);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.shapes12, new cjs.Rectangle(-240.1, -269.5, 480.29999999999995, 539), null);


    (lib.pattern14 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Bitmap2();
        this.instance.parent = this;
        this.instance.setTransform(-316, -114);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern14, new cjs.Rectangle(-316, -114, 624, 227), null);


    (lib.pattern8_in = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Bitmap1();
        this.instance.parent = this;
        this.instance.setTransform(-294, -253);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern8_in, new cjs.Rectangle(-294, -253, 588, 505), null);


    (lib.skull_1 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.skull();
        this.instance.parent = this;
        this.instance.setTransform(-103, -157);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.skull_1, new cjs.Rectangle(-103, -157, 205, 313), null);


    (lib.pistl_1 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.pistl();
        this.instance.parent = this;
        this.instance.setTransform(-303, -287);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pistl_1, new cjs.Rectangle(-303, -287, 606, 574), null);


    (lib.pig_1 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.pig();
        this.instance.parent = this;
        this.instance.setTransform(-83, -65);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pig_1, new cjs.Rectangle(-83, -65, 166, 130), null);


    (lib.gilza_in = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.gilza();
        this.instance.parent = this;
        this.instance.setTransform(-41.5, -41);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.gilza_in, new cjs.Rectangle(-41.5, -41, 83, 82), null);


    (lib.letter_02_L = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill('#1E64F2').beginStroke().moveTo(31.3, 142.9).lineTo(31.3, 103.3).lineTo(57.1, 103.3).lineTo(57.1, 13.1).lineTo(-57.2, 13.1).lineTo(-57.2, 103.3).lineTo(-31, 103.3).lineTo(-31, 142.9).lineTo(-145.9, 142.9).lineTo(-145.9, 103.3).lineTo(-116.8, 103.3).lineTo(-116.8, -103.3).lineTo(-145.9, -103.3).lineTo(-145.9, -142.9).lineTo(-31, -142.9).lineTo(-31, -103.3).lineTo(-57.2, -103.3).lineTo(-57.2, -24.3).lineTo(57.1, -24.3).lineTo(57.1, -103.3).lineTo(31.3, -103.3).lineTo(31.3, -142.9).lineTo(145.8, -142.9).lineTo(145.8, -103.3).lineTo(117, -103.3).lineTo(117, 103.3).lineTo(145.8, 103.3).lineTo(145.8, 142.9).closePath();
        this.shape.setTransform(-0.2, -38.9);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter_02_L, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.pattern8 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.pt = new lib.pattern8_in();
        this.pt.name = 'pt';
        this.pt.parent = this;
        this.pt.setTransform(0, -29);

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern8, new cjs.Rectangle(-294, -282, 588, 505), null);


    (lib.golza = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.gilz3 = new lib.gilza_in();
        this.gilz3.name = 'gilz3';
        this.gilz3.parent = this;
        this.gilz3.setTransform(0.55, 76, 1, 1, -29.9992);

        this.gilz2 = new lib.gilza_in();
        this.gilz2.name = 'gilz2';
        this.gilz2.parent = this;
        this.gilz2.setTransform(82.45, 0, 1, 1, -135.0006);

        this.gilz1 = new lib.gilza_in();
        this.gilz1.name = 'gilz1';
        this.gilz1.parent = this;
        this.gilz1.setTransform(-0.5, 0);

        this.timeline.addTween(cjs.Tween.get({}).to({state: [{t: this.gilz1}, {t: this.gilz2}, {t: this.gilz3}]}).wait(1));

    }).prototype = getMCSymbolPrototype(lib.golza, new cjs.Rectangle(-55.9, -58.3, 196.70000000000002, 190.60000000000002), null);


    (lib.letter = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // letter1
        this.letter1 = new lib.letter_02_L();
        this.letter1.name = 'letter1';
        this.letter1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.letter1).wait(1));

        // letter2
        this.letter2 = new lib.letter_02_L();
        this.letter2.name = 'letter2';
        this.letter2.parent = this;
        this.letter2.setTransform(0, 0, 0.9, 0.9);
        this.letter2.filters = [new cjs.ColorFilter(0.7, 0.7, 0.7, 1, 0, 0, 0, 0)];
        this.letter2.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter2).wait(1));

        // letter3
        this.letter3 = new lib.letter_02_L();
        this.letter3.name = 'letter3';
        this.letter3.parent = this;
        this.letter3.setTransform(0, 0, 0.8, 0.8);
        this.letter3.filters = [new cjs.ColorFilter(0.51, 0.51, 0.51, 1, 0, 0, 0, 0)];
        this.letter3.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter3).wait(1));

        // letter4
        this.letter4 = new lib.letter_02_L();
        this.letter4.name = 'letter4';
        this.letter4.parent = this;
        this.letter4.setTransform(0, 0, 0.7, 0.7);
        this.letter4.filters = [new cjs.ColorFilter(0.21, 0.21, 0.21, 1, 0, 0, 0, 0)];
        this.letter4.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter4).wait(1));

        // letter5
        this.letter5 = new lib.letter_02_L();
        this.letter5.name = 'letter5';
        this.letter5.parent = this;
        this.letter5.setTransform(0, 0, 0.6, 0.6);
        this.letter5.filters = [new cjs.ColorFilter(0, 0, 0, 1, 0, 0, 0, 0)];
        this.letter5.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter5).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.ags = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // skull.png (mask)
        var mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.moveTo(-486.3, -153.9).curveTo(-602.5, -501.1, -273.3, -425.9).lineTo(516.6, -563.9).lineTo(322.6, 536.1).curveTo(186.4, 563.9, 73.1, 563.9).curveTo(-503, 563.9, -486.3, -153.9).closePath();
        mask.setTransform(-239.5257, 50.911);

        // pistl.png
        this.pistl = new lib.pistl_1();
        this.pistl.name = 'pistl';
        this.pistl.parent = this;
        this.pistl.setTransform(414.05, 267.95, 1, 1, -16.7297);

        var maskedShapeInstanceList = [this.pistl];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.pistl).wait(1));

        // Layer_2
        this.letter = new lib.letter();
        this.letter.name = 'letter';
        this.letter.parent = this;
        this.letter.setTransform(38.05, 40);

        this.timeline.addTween(cjs.Tween.get(this.letter).wait(1));

        // pig.png
        this.pig = new lib.pig_1();
        this.pig.name = 'pig';
        this.pig.parent = this;
        this.pig.setTransform(330, -107);

        this.timeline.addTween(cjs.Tween.get(this.pig).wait(1));

        // gilza.png
        this.gilzas = new lib.golza();
        this.gilzas.name = 'gilzas';
        this.gilzas.parent = this;
        this.gilzas.setTransform(-311.5, 225);

        this.timeline.addTween(cjs.Tween.get(this.gilzas).wait(1));

        // robt
        this.skull = new lib.skull_1();
        this.skull.name = 'skull';
        this.skull.parent = this;
        this.skull.setTransform(-427.9, -254.95);

        this.timeline.addTween(cjs.Tween.get(this.skull).wait(1));

        // shapes6
        this.s1 = new lib.shapes12();
        this.s1.name = 's1';
        this.s1.parent = this;
        this.s1.setTransform(211.85, -41.05, 1, 1, -23.9997);

        this.timeline.addTween(cjs.Tween.get(this.s1).wait(1));

        // shapes7 (mask)
        var mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.moveTo(-194.1, 31.2).curveTo(-206.2, 19.1, -206.2, 2).curveTo(-206.2, -15, -194.1, -27.1).curveTo(-182.1, -39.2, -165, -39.2).curveTo(-148, -39.2, -135.9, -27.1).curveTo(-123.8, -15, -123.8, 2).curveTo(-123.8, 19.1, -135.9, 31.2).curveTo(-147.9, 43.2, -165, 43.2).curveTo(-182, 43.2, -194.1, 31.2).closePath();
        mask_1.setTransform(-206.2102, 43.2386);

        // Layer_9
        this.p2 = new lib.pattern14();
        this.p2.name = 'p2';
        this.p2.parent = this;
        this.p2.setTransform(-382.3, 5.7);

        var maskedShapeInstanceList = [this.p2];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(cjs.Tween.get(this.p2).wait(1));

        // shapes7 (mask)
        var mask_2 = new cjs.Shape();
        mask_2._off = true;
        mask_2.graphics.moveTo(-195.4, 60).curveTo(-207.4, 47.9, -207.4, 30.9).curveTo(-207.4, 13.8, -195.4, 1.8).curveTo(-183.3, -10.3, -166.2, -10.3).curveTo(-149.2, -10.3, -137.1, 1.8).curveTo(-125, 13.8, -125, 30.9).curveTo(-125, 47.9, -137.1, 60).curveTo(-149.1, 72.1, -166.2, 72.1).curveTo(-183.3, 72.1, -195.4, 60).closePath();
        mask_2.setTransform(-207.4352, 72.0886);

        // Layer_16
        this.p3 = new lib.pattern14();
        this.p3.name = 'p3';
        this.p3.parent = this;
        this.p3.setTransform(-382.3, 97.85);

        var maskedShapeInstanceList = [this.p3];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
        }

        this.timeline.addTween(cjs.Tween.get(this.p3).wait(1));

        // shapes8 (mask)
        var mask_3 = new cjs.Shape();
        mask_3._off = true;
        mask_3.graphics.moveTo(-95.3, -33.7).curveTo(-100.7, -41.3, -105.8, -55.2).curveTo(-108.9, -64.1, -110.5, -79.9).curveTo(-112, -100.1, -113.7, -111.8).curveTo(-115.2, -122.3, -121.1, -130.6).curveTo(-124.9, -135.9, -133, -143.2).curveTo(-141.3, -150.8, -144.1, -154.6).curveTo(-149, -161.2, -149, -169.3).curveTo(-148.9, -180.9, -140.3, -187.3).curveTo(-132.5, -193.2, -120, -193.2).curveTo(-110.3, -193.2, -103.7, -190.2).curveTo(-99, -188.1, -94.4, -183.5).curveTo(-88.5, -177.6, -86.9, -176.5).curveTo(-82.3, -173.1, -76, -172.7).curveTo(-60.5, -171.4, -52.8, -163.4).curveTo(-46.3, -156.6, -46.3, -146.1).curveTo(-46.2, -139.2, -51.2, -135.6).curveTo(-56.2, -132, -59.7, -128.5).curveTo(-63.1, -125, -65.3, -120.2).curveTo(-67.6, -115.4, -67.6, -105.5).curveTo(-67.6, -96.5, -63.5, -92.2).curveTo(-60.5, -88.7, -49.4, -83.2).curveTo(-28.5, -72.7, -25.5, -70.2).curveTo(-22.3, -67.6, -21.2, -64.5).curveTo(-20, -61.4, -20, -56).curveTo(-20, -45.7, -30.7, -41.2).curveTo(-36.2, -38.8, -49.4, -37.4).curveTo(-54, -36.8, -56.5, -34.1).curveTo(-57.8, -32.6, -59.7, -28.5).curveTo(-61.3, -24.8, -63.1, -23.3).curveTo(-65.9, -20.9, -71.3, -20.9).curveTo(-86.1, -20.9, -95.3, -33.7).closePath();
        mask_3.setTransform(-148.95, -193.2);

        // Layer_7
        this.p4 = new lib.pattern8();
        this.p4.name = 'p4';
        this.p4.parent = this;
        this.p4.setTransform(-340.95, -242.95);

        var maskedShapeInstanceList = [this.p4];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_3;
        }

        this.timeline.addTween(cjs.Tween.get(this.p4).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ags, new cjs.Rectangle(-530.9, -411.9, 1071.8, 1026.6), null);


// stage content:
    (lib._08 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});
		/*
		 // timeline functions:
		 this.frame_0 = function() {
		 var tl = new TimelineMax();
		 var tl2 = new TimelineMax();

		 var time=0.31;
		 var yb=0; // y begin
		 var xb=-10; // x begin
		 var xO=70;// x stop

		 var x5=((xO-xb)/4)*(0)+xb;
		 var x4=((xO-xb)/4)*(1)+xb;
		 var x3=((xO-xb)/4)*(2)+xb;
		 var x2=((xO-xb)/4)*(3)+xb;
		 var x1=((xO-xb)/4)*(4)+xb;


		 tl.set(this.ags, {x:750, y:610});
		 // pistl
		 tl.set(this.ags.pistl, {x:414, y:267, scaleX:0.21, scaleY:0.21,alpha:0,rotation:-16}, "start");
		 tl.to(this.ags.pistl, 2, {x:-188, y:83, scaleX:1, scaleY:1,alpha:1,rotation:0 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.8" )

		 // gilzas
		 tl.set(this.ags.gilzas.gilz1, {x:0, y:0, alpha:0,rotation:-5}, "start");
		 tl.to(this.ags.gilzas.gilz1, 1, {x:20, y:0, alpha:1,rotation:0 }, "start+=1.9" )

		 tl.set(this.ags.gilzas.gilz2, {x:60, y:0, alpha:0,rotation:-135}, "start");
		 tl.to(this.ags.gilzas.gilz2, 1.2, {x:82, y:0, alpha:1,rotation:-130 }, "start+=1.5" )

		 tl.set(this.ags.gilzas.gilz3, {x:0, y:76, alpha:0,rotation:-30}, "start");
		 tl.to(this.ags.gilzas.gilz3, 1, {x:0, y:50, alpha:1,rotation:-35}, "start+=1.1" )

		 // skull

		 tl.set(this.ags.skull, {x:138, y:-68, scaleX:1, scaleY:1,alpha:1}, "start");
		 tl.to(this.ags.skull, 2, {x:-427, y:-254, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.8" )

		 // pig

		 tl.set(this.ags.pig, {x:330, y:-107, scaleX:1, scaleY:1,alpha:0}, "start");
		 tl.to(this.ags.pig, 2, {x:-230, y:-107, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1" )

		 // s1
		 tl.set(this.ags.s1, {x:111, y:-61, scaleX:0.2, scaleY:0.2,alpha:1,rotation:-24}, "start");
		 tl.to(this.ags.s1, 2, {x:-296, y:-87, scaleX:1, scaleY:1,alpha:1,rotation:0 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.8" )

		 // s2
		 tl.set(this.ags.p2.mask, {x:-50, y:-65, scaleX:0, scaleY:0}, "start");
		 tl.to(this.ags.p2.mask,  2, {x:-310, y:160, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")
		 // p2
		 tl.set(this.ags.p2, {x:-100, y:190, scaleX:1, scaleY:1}, "start");
		 tl.to(this.ags.p2,  0.7, {x:-460, y:200, scaleX:1, scaleY:1,rotation:-45,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")

		 // s3
		 tl.set(this.ags.p3.mask, {x:-50, y:-65, scaleX:0, scaleY:0}, "start");
		 tl.to(this.ags.p3.mask,  2, {x:-210, y:50, scaleX:1.5, scaleY:1.5,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")
		 // p3
		 tl.set(this.ags.p3, {x:-100, y:190, scaleX:1, scaleY:1}, "start");
		 tl.to(this.ags.p3,  0.7, {x:-360, y:130, scaleX:1, scaleY:1,rotation:45,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")


		 // s4
		 tl.set(this.ags.p4.mask, {x:-100, y:-100, scaleX:0, scaleY:0}, "start");
		 tl.to(this.ags.p4.mask, 3, {x:-200, y:-220, scaleX:1, scaleY:1, rotation:0,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1.2")


		 // p4
		 tl.set(this.ags.p4, {x:-300, y:-300, scaleX:0.4, scaleY:0.4,rotation:90}, "start");
		 tl.to(this.ags.p4,  4, {x:-300, y:-302, scaleX:0.4, scaleY:0.4,rotation:90,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1.2")
		 tl2.set(this.ags.p4.pt, {y:0, ease:Linear.eaagsone}, "start");
		 tl2.to(this.ags.p4.pt ,  4, {y:-30.8,repeat:-1, ease:Linear.eaagsone}, "start")






		 // ------------ litter---------




		 tl.set(this.ags.letter.letter1, {x:x1, y:yb, alpha:0,}, "start");
		 tl.to(this.ags.letter.letter1 ,  time+0.4, {x:x1, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.022,0.068 0.11,0.478 0.246,0.63 0.367,0.765 0.422,0.85 1,1")}, "start+=0.9")

		 tl.set(this.ags.letter.letter2, {x:x2, y:yb, alpha:0}, "start");
		 tl.to(this.ags.letter.letter2 ,  time+0.4, {x:x2, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.026,0.136 0.064,0.548 0.2,0.7 0.321,0.835 0.406,0.902 1,1")}, "start+=0.8")
		 tl.to(this.ags.letter.letter2 ,  time+0.3, {alpha:0}, "start+=0.98")

		 tl.set(this.ags.letter.letter3, {x:x3, y:yb, alpha:0}, "start");
		 tl.to(this.ags.letter.letter3 ,  time+0.2, {x:x3, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.7")
		 tl.to(this.ags.letter.letter3 ,  time-0.2, {alpha:0}, "start+=0.88")

		 tl.set(this.ags.letter.letter4, {x:x4, y:yb, alpha:0}, "start");
		 tl.to(this.ags.letter.letter4 , time+0.3, {x:x4, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.6")
		 tl.to(this.ags.letter.letter4 , time-0.3, {alpha:0}, "start+=0.78")

		 tl.set(this.ags.letter.letter5, {x:x5, y:yb, alpha:1}, "start");
		 tl.to(this.ags.letter.letter5 ,  time, {x:x5, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0.01,0.406,0,0.708,0.136,0.86,0.257,0.995,0.308,1,1,1")}, "start+=0.4")
		 tl.to(this.ags.letter.letter5 ,  time, {alpha:0}, "start+=0.68")


		 // ------------ litter---------
		 }

		 // actions tween:
		 this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));*/

        // logo_mc
        this.ags = new lib.ags();
        this.ags.name = 'ags';
        this.ags.parent = this;
        this.ags.setTransform(800, 670);

        this.timeline.addTween(cjs.Tween.get(this.ags).wait(1));

        // Layer_1
        this.instance = new lib._08_intro();
        this.instance.parent = this;
        this.instance.setTransform(0, 175);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(625, 770.1, 961.8, 529.9);
// library properties:
    lib.properties = {
        id: 'CF08A2142ADA401E9DA4E5A26203859F',
        width: 1250,
        height: 1250,
        fps: 60,
        color: '#FFFFFF',
        opacity: 1.00,
        manifest: [
            {src: 'images/_08_intro.jpg', id: '_08_intro'},
            {src: 'images/Bitmap1.png', id: 'Bitmap1'},
            {src: 'images/Bitmap2.png', id: 'Bitmap2'},
            {src: 'images/gilza.png', id: 'gilza'},
            {src: 'images/pig.png', id: 'pig'},
            {src: 'images/pistl.png', id: 'pistl'},
            {src: 'images/skull.png', id: 'skull'}
        ],
        preloads: []
    };



// bootstrap callback support:

    (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
    }
    p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition())
    }
    p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    }
    p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
    }
    p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
    }

    p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
    }

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['CF08A2142ADA401E9DA4E5A26203859F'] = {
        getStage: function () {
            return exportRoot.getStage();
        },
        getLibrary: function () {
            return lib;
        },
        getSpriteSheet: function () {
            return ss;
        },
        getImages: function () {
            return img;
        }
    };

    an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);
        for (var j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    }

    an.getComposition = function (id) {
        return an.compositions[id];
    }



})(createjs = createjs||{}, AdobeAn = AdobeAn||{});

// export const AdobeAn = AdobeAn;
export const composition = AdobeAn.getComposition('CF08A2142ADA401E9DA4E5A26203859F');